<sd-title [titleLevel]="2" id="{{ name }}">{{ title }}</sd-title>
<sd-html [html]="content" tag="div" />
